import React, { useState } from 'react';
import moment from 'moment';
import { Modal, Row, Col, Tabs } from 'antd';
import { ToothSample } from '../../../models';
import {buildSampleResult, isYounger } from "../../../common";
import { HospitalPerson } from '../components/HospitalPerson';
import { AItem } from '../../../components/sample/AItem';
import { BItem } from '../../../components/sample/BItem';
import { CItem } from '../../../components/sample/CItem';
import { CATItem } from '../../../components/sample/CATItem';
import { loginInfo } from '../../../config';
interface PropsType {
  visible: boolean;
  add: Function;
  setInvisible: Function;
  editRecord:ToothSample;
}
export const HospitalSampleAdd: React.FC<PropsType> = ({ visible, add, setInvisible, editRecord }) => {
  const [age, setAge] = useState(5);

  const handlerOk = async () => {
    let sample: ToothSample = {...editRecord};
    
    sample.hospitalId = loginInfo.user.hospitalId;
    sample.hospitalName = loginInfo.user.hospitalName;
    
    sample.initId = loginInfo.user.id;
    sample.initName = loginInfo.user.userName;
    sample.initDate = moment().format("YYYY-MM-DD HH:mm:ss");
    sample.status = "初始化";

    sample.samplingDate = moment().format("YYYY-MM-DD HH:mm:ss");
    let hasFillin = true, hasSampling = true;
    if (editRecord.a1 === "否" || editRecord.a2 === "否") {
      hasFillin = false;
    }
    if (isYounger(age)) {
      if (editRecord.a3 === "否" || editRecord.a4 === "否") {
        hasFillin = false;
      }
    }
    if (editRecord.b1 === "否" || editRecord.b2 === "否" || editRecord.b3 === "否" || editRecord.b4 === "否") {
      hasFillin = false;
    }

    if (hasFillin) {
      sample.fillinDate = moment().format("YYYY-MM-DD HH:mm:ss");
      sample.fillinId = loginInfo.user.id;
      sample.fillinName = loginInfo.user.userName;
      sample.status = "数据填报";
    }

    if (editRecord.c2 === "否" || editRecord.c3 === "否" || editRecord.c4 === "否") {
      hasSampling = false;
    }

    if (!isYounger(age)) {
      if (editRecord.c5 === "否") {
        hasSampling = false;
      }
    }
    if (hasSampling) {
      sample.samplingDate = moment().format("YYYY-MM-DD HH:mm:ss");
      sample.samplingId = loginInfo.user.id;
      sample.samplingName = loginInfo.user.userName;
      sample.status = "临床检查与采样";
    }

    if (editRecord.cat !== -1) {
      sample.cat = editRecord.cat;
      //if (hasFillin && hasSampling) {
        buildSampleResult(sample);
        sample.checkDate = moment().format("YYYY-MM-DD HH:mm:ss");
        sample.checkId = loginInfo.user.id;
        sample.checkName = loginInfo.user.userName;
        sample.status = "检测";
      //}
    }

    sample.type = 1;
    add(sample);
    setInvisible();
  }
  
  const handlerCancel = () => {
    setInvisible();
  }

  return (
    <>
      <Modal
        title="添加医院检测受检人"
        visible={visible}
        onOk={handlerOk}
        onCancel={handlerCancel}
        okText='保存'
        cancelText='取消'
      >   
          <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="受检人信息" key="1">
            <HospitalPerson editRecord={editRecord} setAge={setAge} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="生物学因素" key="2">
            <AItem editRecord={editRecord} age={age} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="保护性因素" key="3">
            <BItem editRecord={editRecord} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="临床检查" key="4">
            <CItem editRecord={editRecord} age={age} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="CAT检测" key="5">
            <CATItem editRecord={editRecord}/>
          </Tabs.TabPane>
        </Tabs>
        
      </Modal>

    </>
  )
};